import { socketService } from './socket';
import { AuthRequest, AuthResponse, TFARequest } from '../types';
import { getDeviceInfo } from '../utils/deviceInfo';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

class AuthService {
  async login(username: string, password: string): Promise<AuthResponse> {
    const deviceInfo = await getDeviceInfo();
    
    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
          installId: deviceInfo.installId,
          deviceInfo
        })
      });

      const data = await response.json();

      return data;
    } catch (error) {
      throw new Error(error instanceof Error ? error.message : 'Network error');
    }
  }

  async verifyTFA(username: string, password: string, tfaCode: string, sessionId: string): Promise<AuthResponse> {
    const deviceInfo = await getDeviceInfo();
    
    try {
      const response = await fetch(`${API_URL}/api/auth/login/tfa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
          tfaCode,
          installId: deviceInfo.installId,
          sessionId
        })
      });

      const data = await response.json();

      return data;
    } catch (error) {
      throw new Error(error instanceof Error ? error.message : 'Network error');
    }
  }

  async logout(): Promise<boolean> {
    return new Promise((resolve) => {
      socketService.getSocket()?.emit('logout', (success: boolean) => {
        resolve(success);
      });
    });
  }

  async refreshToken(refreshToken: string): Promise<{ accessToken: string; sessionId: string }> {
    return new Promise((resolve, reject) => {
      socketService.getSocket()?.emit('refreshToken', refreshToken, (response: any) => {
        if (response.success) {
          resolve({
            accessToken: response.accessToken,
            sessionId: response.sessionId
          });
        } else {
          reject(new Error(response.error || 'Token refresh failed'));
        }
      });
    });
  }
}

export const authService = new AuthService();